module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-12-zoom.35f2991b.png";